import { render, staticRenderFns } from "./PayReferralSelector.vue?vue&type=template&id=08f76ca3&"
import script from "./PayReferralSelector.vue?vue&type=script&lang=js&"
export * from "./PayReferralSelector.vue?vue&type=script&lang=js&"
import style0 from "./PayReferralSelector.vue?vue&type=style&index=0&id=08f76ca3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports